import { GeographicDistributionSchema } from "../api/schema";

export const rankColor = (rank: number) => {
  if (rank === 1) return "linear-gradient(180deg, #FFD86B 0%, #FBBF24 100%)";
  if (rank === 2) return "linear-gradient(180deg, #aeaeae 0%, #cedbf2 100%)";
  if (rank === 3) return "linear-gradient(180deg, #c68744 0%, #FB923C 100%)";
  return "linear-gradient(180deg, #94A3B8 0%, #64748B 100%)";
};

export const normalizeProductLabel = (label: string): keyof typeof PRODUCT_COLORS_BUBBLE => {
  const value = label.toLowerCase();

  if (value.includes("konsulta")) {
    return "Konsulta";
  }


  if (value.includes("beacon")) {
    return "Beacon";
  }


  if (value.includes("hih") || value.includes("profiling")) {
    return "HIH";
  }

  return "MULTIPLE";
};
export const PRODUCT_COLORS_LABEL: Record<string, string> = {
  HealthInformationHub: "#0f69aa",
  HIH: "#0f69aa",                  
  Konsulta: "#ffc300",
  Beacon: "#00d4ff",
  MULTIPLE: "#ff5f47",
};


export const PRODUCT_COLORS_BUBBLE: Record<string, string> = {
  "Health Information Hub": "#123257",
  HIH: "#123257",
  Konsulta: "#ffc300",
  Beacon: "#00d4ff",
  MULTIPLE: "#ff5f47",
};

export const getFacilityCountForRegion = (
  region: GeographicDistributionSchema,
  activeFilter?: string,
) => {
  if (
    !activeFilter ||
    activeFilter === "All Products" ||
    activeFilter === "Multiple Products"
  ) {
    return region.distribution.reduce((sum, item) => sum + item.value, 0);
  }

  const match = region.distribution.find((item) => item.label === activeFilter);

  return match?.value ?? 0;
};

export const getUniqueProducts = (region: GeographicDistributionSchema) => {
  return new Set(region.distribution.map((d) => d.label));
};

export const shouldRenderRegion = (
  region: GeographicDistributionSchema,
  activeFilter?: string,
) => {
  if (!activeFilter || activeFilter === "All Products") return true;

  const uniqueProducts = getUniqueProducts(region);

  if (activeFilter === "Multiple Products") {
    return uniqueProducts.size > 1;
  }

  return uniqueProducts.has(activeFilter);
};

export const getRegionColor = (
  region: GeographicDistributionSchema,
  activeFilter?: string,
) => {
  const uniqueProducts = getUniqueProducts(region);

  if (!activeFilter || activeFilter === "All Products") {
    if (uniqueProducts.size > 1) return PRODUCT_COLORS_BUBBLE.MULTIPLE;

    const onlyProduct = Array.from(uniqueProducts)[0];
    return PRODUCT_COLORS_BUBBLE[onlyProduct] ?? PRODUCT_COLORS_BUBBLE.MULTIPLE;
  }

  if (activeFilter === "Multiple Products") {
    return PRODUCT_COLORS_BUBBLE.MULTIPLE;
  }

  return PRODUCT_COLORS_BUBBLE[activeFilter] ?? PRODUCT_COLORS_BUBBLE.MULTIPLE;
};